module.exports = __webpack_public_path__ + "static/media/account-deleted-2.c33ca2b5.png";